<div class="laptop-layout bg-gradient" [class.sidebar-collapsed]="sidebarCollapsed()">
  <!-- Sidebar -->
  <div class="sidebar-container hv-shell-sidebar">
    <app-desktop-sidebar [(collapsed)]="sidebarCollapsed" />
  </div>

  <!-- Main area that contains the header and content -->
  <div class="main-area">


    <!-- Content area that splits into main content and aside -->
    <div class="content-area">
      <!-- Region 3: Main Content -->
      <main class="main-content-container">
        <!-- Pass context from the service to the component via inputs -->
        <!-- @if (pageContextService.pageTitle(); as title) {
        <app-page-header
          [title]="title"
          [subtitle]="pageContextService.pageSubtitle() || undefined"
          [actions]="pageContextService.actions()"
          [primaryAction]="pageContextService.fabAction()"
        />
        } -->

        <!-- Page Sub-Header (Sticky & Conditional) -->
        @if (pageContextService.subHeaderContent(); as content) {
        <div class="sub-header-wrapper">
          @if (isTemplateRef(content)) {
          <ng-container [ngTemplateOutlet]="content"></ng-container>
          } @else {
          <!-- Otherwise, it's a DynamicComponent, so use ngComponentOutlet -->
          <ng-container
            [ngComponentOutlet]="content.component"
            [ngComponentOutletInputs]="content.inputs"
          >
          </ng-container>
          }
        </div>
        }

        <!-- The actual page content -->
        <div class="page-body-container">
          <app-toast-stack />
          <router-outlet></router-outlet>
          @defer (when featureFlags.aiAssistantEligible()) {
            @if (featureFlags.aiAssistantEnabled()) {
              <app-assistant-widget />
            }
          }
        </div>
      </main>

      <!-- Region 4: Primary Aside -->
      @if (asideService.asideContext(); as context) {
      <aside
        animate.enter="hv-aside-enter"
        animate.leave="hv-aside-leave"
        class="aside-container flex flex-col"
        [style.width.px]="asideWidth()"
      >
        <!-- FIX: Add resize handle -->
        <div class="resize-handle" (mousedown)="onResizeStart($event)"></div>

        <!-- Aside Header -->
        <div
          class="mb-2 mx-2 flex-shrink-0 px-3 py-2.5 flex items-center justify-between gap-2 rounded-xl border-1 border-border bg-surface"
        >
          <app-heading level="h3" class="truncate min-w-0">{{ context.title }}</app-heading>
          <div class="flex items-center gap-1 shrink-0">
            @if (asideService.headerAction(); as action) {
              @if (action.label) {
                <app-button
                  variant="ghost"
                  size="xs"
                  [icon]="action.icon"
                  [title]="action.tooltip || action.label"
                  [attr.aria-label]="action.tooltip || action.label"
                  (click)="action.onClick()"
                >
                  {{ action.label }}
                </app-button>
              } @else {
                <app-button
                  variant="ghost"
                  size="sm"
                  [iconOnly]="true"
                  [icon]="action.icon"
                  shape="circle"
                  [title]="action.tooltip || 'Open details'"
                  [attr.aria-label]="action.tooltip || 'Open details'"
                  (click)="action.onClick()"
                />
              }
            }
            <app-button
              (click)="asideService.close()"
              variant="ghost"
              size="sm"
              [iconOnly]="true"
              icon="X"
              shape="circle"
              title="Close"
              aria-label="Close"
            >
            </app-button>
          </div>
        </div>

        <!-- Aside Body -->
        <div class="flex-grow overflow-y-auto p-1">
          <app-aside-content></app-aside-content>
        </div>

        <!-- FIX: Add a persistent footer with a "Done" button -->
        <!-- <div
          class="mt-2 mx-2 flex-shrink-0 p-4 rounded-xl border-1 border-border bg-surface"
        >
          <app-button
            (click)="asideService.close()"
            class="w-full"
            icon="circle-check"
          >
            Done
          </app-button>
        </div> -->
      </aside>
      }
    </div>
  </div>
</div>
